import React from 'react';
import DatePicker from 'react-datepicker';
import { Input, Label } from '../../components/Bootstrap';

export class DateField extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.props.onChange(value?.toISOString());
  }

  render() {
    const value = new Date(this.props.formData);

    return (
      <div>
        <Label>{this.props.schema.title}</Label>
        <DatePicker
          showYearDropdown={true}
          selected={value}
          onChange={this.onChange}
          dateFormat='MM/dd/yyyy'
          placeholderText={this.props.uiSchema['ui:placeholder']}
          customInput={<Input />}
        />
      </div>
    );
  }
}
